/**
 * CallTimer — displays elapsed call duration as MM:SS
 */

import { useState, useEffect } from 'react';

interface CallTimerProps {
  startedAt: Date;
  className?: string;
}

export function CallTimer({ startedAt, className = '' }: CallTimerProps) {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setElapsed(Math.floor((Date.now() - startedAt.getTime()) / 1000));
    }, 1000);
    return () => clearInterval(interval);
  }, [startedAt]);

  const minutes = Math.floor(elapsed / 60);
  const seconds = elapsed % 60;
  const display = `${minutes}:${seconds.toString().padStart(2, '0')}`;

  return <span className={className}>{display}</span>;
}
